import { MediaRegistry } from 'js/src/agent/registries/MediaRegistry';
import { VoiceoverRegistry } from 'js/src/agent/registries/VoiceoverRegistry';
import type { UploadedFile } from 'js/src/components/sketch/FileUpload';
import { isUploadedAudio, isUploadedMedia } from 'js/src/components/sketch/FileUpload';

/**
 * Where an attachment in the chat transcript points.
 *
 * The message text only carries a short registry id, so the asset uuid a link needs is
 * recovered from the registry here. Returns undefined when there is nothing to open --
 * an upload still in flight, or a document typed rather than uploaded.
 */
export function getAttachmentUrl(file: UploadedFile): string | undefined {
    if (file.isUploading) {
        return undefined;
    }

    if (isUploadedMedia(file)) {
        const uuid =
            file.uuid ?? resolveRegistryUuid(MediaRegistry.getInstance(), file.mediaRegistryId);
        return uuid ? `/attachment/media/${uuid}/` : undefined;
    }

    if (isUploadedAudio(file)) {
        const uuid =
            file.uuid ??
            resolveRegistryUuid(VoiceoverRegistry.getInstance(), file.voiceoverRegistryId);
        return uuid ? `/attachment/media/${uuid}/` : undefined;
    }

    return file.documentId ? `/attachment/document/${file.documentId}/` : undefined;
}

function resolveRegistryUuid(
    registry: { getUuidByItemId: (id: string) => string | undefined },
    registryId: string | undefined,
): string | undefined {
    return registryId ? registry.getUuidByItemId(registryId) : undefined;
}
